import routes from 'global/Constants/routes';
import { lazy } from 'react';

const Substation = lazy(() => import('../../pages/dashboard/substation/Substation'));

export const substationRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.substation.path,
    component: Substation,
    isPrivate: routes.substation.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
